import React from 'react';
import { FadeIn } from './Shared';
export function HowItWorks() {
  const steps = [{
    num: '01',
    title: 'Switch the Hardware',
    desc: 'Move from fixed disposables to a refillable pod system.'
  }, {
    num: '02',
    title: 'Follow the Ladder',
    desc: 'Mix your liquid according to the Week 1, 2, and 3 ratios.'
  }, {
    num: '03',
    title: 'Break the Ghost',
    desc: 'Use the sensory substitution methods to kill the physical habit forever.'
  }];
  return <section className="py-24 px-4 bg-neutral-950 relative border-t border-neutral-900" data-id="element-71">
      <div className="max-w-5xl mx-auto" data-id="element-72">
        <FadeIn data-id="element-73">
          <div className="text-center mb-16" data-id="element-74">
            <h2 className="text-4xl md:text-5xl font-black uppercase mb-6" data-id="element-75">
              How It Works
            </h2>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-76">
          {steps.map((step, i) => <FadeIn key={i} delay={i * 0.1} data-id="element-77">
              <div className="relative p-8 border border-neutral-800 bg-[#111] hover:bg-neutral-900 transition-colors" data-id="element-78">
                <div className="text-6xl font-black text-neutral-800 absolute top-4 right-4 select-none" data-id="element-79">
                  {step.num}
                </div>
                <div className="relative z-10 mt-8" data-id="element-80">
                  <h3 className="text-xl font-display font-bold text-white mb-4" data-id="element-81">
                    {step.title}
                  </h3>
                  <p className="text-neutral-400 leading-relaxed" data-id="element-82">
                    {step.desc}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}